import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { isUndefined } from 'lodash'

const RadialChart1 = ({ totalOrders }) => {
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (!isUndefined(totalOrders)) {
      setSeries([totalOrders]);
    }
  }, [totalOrders]);

  const radialoptions = {
    chart: {
      type: 'radialBar',
      sparkline: {
        enabled: true
      }
    },
    dataLabels: {
      enabled: false
    },
    colors: ['#E42626'],
    stroke: {
      lineCap: 'round'
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '70%'
        },
        track: {
          margin: 0,
        },

        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: 5,
            show: false
          }
        }
      }
    }
  };
  return (
    <React.Fragment>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <ReactApexChart
          options={radialoptions}
          series={series}
          type="radialBar"
          height="72"
          width="72"

        />
        <div className="dash-icon">
          <i className="bx bxs-cart-alt"></i>
        </div>
      </div>
    </React.Fragment>
  )
}

export default RadialChart1;
